export const imgs = [
  {
    key: 'phone1',
    src: '/new/editorial-media/phone_1.png',
  },
  {
    key: 'phone2',
    src: '/new/editorial-media/phone_2.png',
  },
];
